/* global ol */
import ExtremeMapLandmarkLayerManager from '@/lib/ExtremeMapLandmarkLayerManager'
// import * as EVT from '@/consts/eventNames'
import Stream from '@/lib/Stream'

export default class ExtremeMapRecLayerManager extends ExtremeMapLandmarkLayerManager {
  constructor() {
    super()
    this.clickInfo = {
      counter: 0,
      points: [],
    }
    this.vectorSource = new ol.source.Vector()
    this.setStream(new Stream({ name: 'recLayer', debug: false }))
  }

  getColorMap_() {
    const fill = {
      purple: '#d442f4',
    }
    const stroke = {
      purple: '#a633bf',
    }
    return {
      point: {
        fill: Object.assign({}, fill),
        stroke: Object.assign({}, stroke),
      }
    }
  }

  getDefaultColor_() {
    return 'purple'
  }

  getNewPointStyle_({ color, text }) {
    const colorMap = this.getColorMap_()
    const fillColor = colorMap.point.fill[color]
    const strokeColor = colorMap.point.stroke[color]
    const ret = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 3,
        fill: new ol.style.Fill({
          color: fillColor,
        }),
        stroke: new ol.style.Stroke({
          color: strokeColor,
          width: 1
        })
      }),
    })
    if (text) {
      ret.setText(new ol.style.Text({
        text: text,
        font: '8px sans-serif',
        fill: new ol.style.Fill({
          color: 'black'
        }),
        stroke: new ol.style.Stroke({
          color: 'rgba(255, 255, 255, 0.8)',
          width: 2,
        }),
        offsetX: 0,
        offsetY: 12,
      }))
    }
    return ret
  }

  getNewPointFeature_(point, info) {
    const feat = new ol.Feature({
      geometry: new ol.geom.Point(point)
    })
    feat.setId(info.id)
    const style = this.getNewPointStyle_({
      color: info.defaultColor,
      text: info.text,
    })
    style.setZIndex(info.zIndex++)
    feat.setStyle(style)
    return feat
  }

  addPoint(coord) {
    const coordConv = this.convCoord({
      lon: coord[0],
      lat: coord[1],
    }, {
      srcProj: 'EPSG:3857',
      destProj: 'EPSG:4326',
    })
    this.clickInfo.points.push(coordConv)

    const nextNum = ++this.clickInfo.counter
    const id = `rec-point-${nextNum}`
    const text = nextNum.toString()
    const info = { id, text, defaultColor: this.getDefaultColor_() }
    const feat = this.getNewPointFeature_(coord, info)
    this.vectorSource.addFeature(feat)
  }

  removePoint(featId) {
    const feat = this.vectorSource.getFeatureById(featId)
    if (!feat) { return }
    this.vectorSource.removeFeature(feat)

    const num = parseInt(featId.split('rec-point-')[1])
    this.clickInfo.points.splice(num - 1, 1)
  }

  onMapClick(coord) {
    this.addPoint(coord)
  }

  dumpPoints() {
    console.log('--- ExtremeMapRecLayerManager#dumpPoints ---')
    this.clickInfo.points.forEach(e => {
      const lat = e[1].toFixed(6)
      const lon = e[0].toFixed(6)
      console.log(`${lat}, ${lon}`)
    })
  }

  createLayer_() {
    this.vectorSource = new ol.source.Vector()
    const layer = new ol.layer.Vector({
      source: this.vectorSource,
    })
    layer.name = 'rec'
    this.layer = layer

    this.layerInfo.onClick = ({ event, feature }) => {
      // 重なってたりする場合はそれぞれ飛んでくるので、一回で止める
      if (event.originalEvent.defaultPrevented) { return }
      event.preventDefault()
      const featId = feature.getId()
      this.removePoint(featId)
    }
  }

  prepareLayer() {
    this.createLayer_()
    return this.getLayer()
  }
}
